import { creators as userCreators } from '../ducks/userDuck';
import { getConfigurationAction } from './configuration';

export const setActiveRole = role => async dispatch => {
  dispatch(userCreators.setActiveRole(role));
  dispatch(getConfigurationAction());
};
